export interface INotificationTemplate {
    id?: string;
    user_id: string|null;
    name?: string|undefined|null;
    slots: INotificationToSlots[] | undefined| null;

    _deleted?: boolean,
    _has_changes?: boolean,
}


export interface INotificationToSlots {
    id?: number;
    slot_id?: string,
    slot_name?: string|undefined|null,
    slot: ISlot|undefined|null;
    _deleted?: boolean,
    _has_changes?: boolean,
}

export interface ISlot {
    id?: number;
    user_id?: string;
    name?: string|undefined;
    templates: ITemplate[]|undefined|null;
    created_at?: Date;
    updated_at?: Date;
    deleted_at?: Date;

    _deleted?: boolean,
    _has_changes?: boolean,
}

export interface ITemplate {
    id?: string,
    locale?: string,
    content?: string|null,
    _deleted?: boolean,
    _has_changes?: boolean,
}
export enum SLOT_TYPE {
    SUBJECT = 'subject',
    HEADER = 'header',
    CONTENT = 'content',
    FOOTER = 'footer',
}
